"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.actions.run': 'Run Test',
    'botTest.actions.results': 'View Results',
};
